import core from '@/store/modules/sessionState/permissions/core';
import discard from '@/store/modules/sessionState/permissions/discard';
import draw from '@/store/modules/sessionState/permissions/draw';
import hand from '@/store/modules/sessionState/permissions/hand';
import match from '@/store/modules/sessionState/permissions/match';
import melds from '@/store/modules/sessionState/permissions/melds';

export default {
    core,
    discard,
    draw,
    hand,
    match,
    melds,
};
